// constants
import { FaqActionTypes } from "./constants";

export interface FaqActionType {
  type:
    | FaqActionTypes.API_RESPONSE_SUCCESS
    | FaqActionTypes.API_RESPONSE_ERROR
    | FaqActionTypes.UPDATE_FAQ
    | FaqActionTypes.CREATE_FAQ
    | FaqActionTypes.GET_FAQ
    | FaqActionTypes.DELETE_FAQ;
  payload: {} | string;
}

interface newsDetails {
  id: string;
  question_en: string;
  question_ar: string;
  answer_en: string;
  answer_ar: string;
}

// common success
export const faqApiResponseSuccess = (
  actionType: string,
  data: newsDetails | {}
): FaqActionType => ({
  type: FaqActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const faqApiResponseError = (
  actionType: string,
  error: string
): FaqActionType => ({
  type: FaqActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const createFaq = (
  question_en: string,
  question_ar: string,
  answer_en: string,
  answer_ar: string
): FaqActionType => ({
  type: FaqActionTypes.CREATE_FAQ,
  payload: { question_en, question_ar, answer_en, answer_ar },
});

export const getFaq = (): FaqActionType => ({
  type: FaqActionTypes.GET_FAQ,
  payload: {},
});

export const deleteFaq = (id: string): FaqActionType => ({
  type: FaqActionTypes.DELETE_FAQ,
  payload: { id },
});
export const updateFaq = (
  id: string,
  question_en: string,
  question_ar: string,
  answer_en: string,
  answer_ar: string
): FaqActionType => ({
  type: FaqActionTypes.UPDATE_FAQ,
  payload: { id, question_en, question_ar, answer_en, answer_ar },
});
